/**
 * vDrive partner console API (apps/deliveries). Every organization-scoped
 * route lives under this prefix; the backend checks that the caller is an
 * active member and answers 404 for anyone else's organization.
 */
export const vdOrgPath = (orgId: number | string) =>
  `/v1/organizations/${orgId}`;
